<tui-hosted-dropdown
  class="w-full"
  tuiDropdownAlign="left"
  [(open)]="hostedOpen"
  [content]="dropdown"
>
  <div
    tuiHostedDropdownHost
    class="flex flex-row justify-between items-center cursor-pointer w-full flex-nowrap relative"
  >
    <div
      class="flex justify-start items-center tui-text_body-m-4 tui-base-01 w-full"
      [ngClass]="{
        'flex-col': basePanelService.routeData.shortLeftNavigation,
        'pr-6': !basePanelService.routeData.shortLeftNavigation
      }"
    >
      <tui-avatar
        [class.mr-2]="!basePanelService.routeData.shortLeftNavigation"
        [text]="(userService.currentUser$ | async)?.fullName ?? ''"
        [size]="basePanelService.routeData.shortLeftNavigation ? 's' : 'm'"
        [avatarUrl]="
          (userService.currentUser$ | async)?.avatar
            ? Config.ASSETS + (userService.currentUser$ | async)?.avatar?.file
            : ''
        "
        [autoColor]="true"
        [rounded]="true"
      ></tui-avatar>
      <div class="overflow-hidden overflow-ellipsis flex flex-col justify-center items-start">
        <span
          class="overflow-ellipsis whitespace-nowrap overflow-hidden w-full"
          *ngIf="!basePanelService?.routeData?.shortLeftNavigation"
          >{{ (userService.currentUser$ | async)?.fullName }}</span
        >
        <df-user-credits-badge></df-user-credits-badge>
      </div>
    </div>
    <svg-icon
      class="absolute right-0"
      [src]="'/assets/img/More-Vert.svg'"
      *ngIf="!basePanelService?.routeData?.shortLeftNavigation"
    ></svg-icon>
  </div>
</tui-hosted-dropdown>

<ng-template #dropdown>
  <tui-data-list>
    <a
      tuiOption
      [routerLink]="n.getPath('users/preview/:id', {}, { id: userService.User?.id })"
      (click)="hostedOpen = false"
      class="tui-primary flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        [src]="'/assets/img/Profile.svg'"
        class="mr-2"
      ></svg-icon>
      {{ 'Navigation.My Profile' | translate }}
    </a>
    <a
      tuiOption
      [routerLink]="n.getPath('account/settings/personal-data')"
      (click)="hostedOpen = false"
      class="flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        [src]="'/assets/img/Settings.svg'"
        class="mr-2"
      ></svg-icon>
      {{ 'Navigation.Account Settings' | translate }}
    </a>
    <a
      *ngIf="!userService.User?.isSemrushPlan()"
      tuiOption
      [routerLink]="n.getPath('account/services/orders')"
      (click)="hostedOpen = false"
      class="flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        [src]="'/assets/img/ic_suitcase_alt.svg'"
        class="mr-2"
      ></svg-icon>
      {{ 'Navigation.My services' | translate }}
    </a>
    <a
      *ngIf="!userService.User?.isSemrushPlan()"
      tuiOption
      [routerLink]="n.getPath('account/settings/teams')"
      (click)="hostedOpen = false"
      class="flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        [src]="'/assets/img/_ic_users.svg'"
        class="mr-2"
      ></svg-icon>
      {{ 'Navigation.My teams' | translate }}
    </a>
    <a
      *ngIf="!userService.User?.isSemrushPlan()"
      tuiOption
      (click)="logout(); hostedOpen = false"
      class="tui-accent flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        [src]="'/assets/img/Turn_on.svg'"
        class="mr-2"
      ></svg-icon>
      {{ 'Navigation.Log Out' | translate }}
    </a>
  </tui-data-list>
</ng-template>
